<template>
  <div class="notices">
    <div style="margin-bottom: 10px;">
      <el-row :gutter="40">
        <el-col :span="6">
          <el-text style="font-size: larger; font-weight: bolder;">定向选调 - 资讯</el-text>
        </el-col>
        <el-col :span="18">
          <el-text style="font-size: larger; font-weight: bolder;">当前选中省份：{{ data.province }}</el-text>
        </el-col> 
      </el-row>
    </div>
    <el-row :gutter="40">
      <el-col :span="6">
        <el-table :data="data.provinces" border style="width: 100%; height: calc(100vh - 140px);" @row-click="(row) => { data.province = row.kkey; resetSearchParam(); commitFindList()}">
          <el-table-column prop="kkey" label="省份选择" align="center" />
        </el-table>
      </el-col>
      <el-col :span="18">
        <el-form :inline="true">
          <el-form-item>
            <el-button-group>
              <el-button type="primary" @click="commitFindList()" :loading="loading.find">刷新</el-button>
            </el-button-group>
          </el-form-item>
          <el-form-item>
            <el-button-group>
              <el-button type="primary" @click="add()">新增</el-button>
              <el-button type="warning" :disabled="show.selected.length != 1" @click="update()">详情</el-button>
              <el-button type="danger" :disabled="show.selected.length < 1" @click="del()">删除</el-button>
            </el-button-group>
          </el-form-item>
        </el-form>
        <el-table :data="data.noticeList" @selection-change="selectionChange()" ref="tabRef" border style="height: calc(100vh - 190px);" v-loading="loading.find">
          <el-table-column type="selection" width="55" align="center" />
                <el-table-column prop="title" label="标题" show-overflow-tooltip>
            <template #default="scope">
              <el-link type="primary" @click="update(scope.row)">{{ scope.row.title }}</el-link>
            </template>
          </el-table-column>
          <el-table-column prop="hasShow" label="是否展示" width="100" show-overflow-tooltip>
            <template #default="scope">
              <el-text>{{ scope.row.hasShow ? '是' : '否' }}</el-text>
            </template>
          </el-table-column>
          <el-table-column prop="sort" label="排序" width="100" show-overflow-tooltip />
        </el-table>
      </el-col>
    </el-row>
    <div style="height: 10px;" />
  </div>
</template>

<script setup>
import { reactive, ref } from 'vue'
import { useRouter } from 'vue-router'
import { ElMessage, ElMessageBox } from 'element-plus'
import api from '../../apis/api'
import apiNative from '../../apis/apiNative'
import cache from '../../utils/cache'
import util from '../../utils/util'
import math from '../../utils/math'

const router = useRouter()
const tabRef = ref()

const loading = reactive({
  find: false,
})
const provinces = reactive(["北京市", "天津市", "河北省", "山西省", "内蒙古自治区", "辽宁省", "吉林省", "黑龙江省", "上海市", "江苏省", "浙江省", "安徽省", "福建省", "江西省", "山东省", "河南省", "湖北省", "湖南省", "广东省", "广西壮族自治区", "海南省", "重庆市", "四川省", "贵州省", "云南省", "西藏自治区", "陕西省", "甘肃省", "青海省", "宁夏回族自治区", "新疆维吾尔自治区", "台湾省", "香港特别行政区", "澳门特别行政区"])
const data = reactive({
  provinces: [],
  province: '',
  noticeList: [],
})

const show = reactive({
  selected: [],
})

const cacheSearchParam = cache.getObject(cache.keys.pageParam + 'dxxds_notices')

const searchParam = reactive({})
const resetSearchParam = () => {
  searchParam.type = 'DXXDS',
  searchParam.kkey = data.province
}

/** 查询全部省份 */
const getProvinces = () => {
  api.get('/backend/kkv/getList', {
    params: {
      scene: 'DX_P'
    }
  }).then((res) => {
    if (res && res.list && res.list.length > 0) {
      data.provinces = []
      provinces.forEach((item) => {
        for (const i of res.list) {
          if (i.value === item) {
            data.provinces.push(i)
            break
          }
        }
      })
      if (!data.province) {
        data.province = res.list[0].kkey
        if (cacheSearchParam) {
          cache.setObject(cache.keys.pageParam + 'dxxds_notices', null)
          data.province = cacheSearchParam.kkey
        }
        resetSearchParam()
        commitFindList()
      }
    } else {
      data.provinces = []
      data.province = ''
    }
  })
}
getProvinces()

const commitFindList = () => {
  api.get('/backend/notice/getNoticeList', { params: searchParam }).then(res => {
    data.noticeList = res.list
  }).finally(() => {
    loading.find = false
  })
}

const selectionChange = () => {
  show.selected = tabRef.value.getSelectionRows()
}

const add = () => {
  if (!data.province) {
    ElMessage.warning('请先选择省份')
    return
  }
  cache.setObject(cache.keys.pageParam + 'dxxds_notices', searchParam)
  cache.setObject(cache.keys.pageParam + 'dxxds_notice', { kkey: data.province, sort: 0 })
  router.push('/dxxds_notice')
}

const del = () => {
  const notices = tabRef.value.getSelectionRows()
  const noticeIdList = notices.map(notice => notice.id)
  ElMessageBox.confirm('', {
    title: '确认删除',
    message: '将要删除选中的项？',
    autofocus: false,
    confirmButtonText: '删除',
    cancelButtonText: '取消',
  }).then(() => {
    api.post('/backend/notice/delNotice', { ids: noticeIdList }).then(() => {
      ElMessage.success('删除成功')
      commitFindList()
    })
  })
}

const update = (row) => {
  cache.setObject(cache.keys.pageParam + 'dxxds_notices', searchParam)
  const notice = row ? row : tabRef.value.getSelectionRows()[0]
  cache.setObject(cache.keys.pageParam + 'dxxds_notice', notice)
  router.push('/dxxds_notice')
}
</script>

<style lang="less"></style>